import { useEffect, useRef } from "react";

import { Textarea } from "./ui/textarea";

const AutoResizeTextarea = ({ value, onChange, ...props }) => {
  const textareaRef = useRef(null);

  const resizeTextarea = () => {
    const textarea = textareaRef.current;

    if (textarea) {
      textarea.style.height = "auto"; // Reset the height
      textarea.style.height = `${textarea.scrollHeight}px`; // Set the height to match the scroll height
    }
  };

  // Function to auto resize the textarea
  const handleInput = (e) => {
    resizeTextarea();
    onChange(e);
  };

  const handleChange = (e) => {
    resizeTextarea();
    onChange(e);
  };

  useEffect(() => {
    resizeTextarea();
  });

  return (
    <Textarea
      ref={textareaRef}
      value={value}
      onInput={handleInput}
      onChange={handleChange}
      style={{ minHeight: "150px", overflow: "hidden" }}
      {...props} // Pass down any other props
    />
  );
};

export default AutoResizeTextarea;
